import { isActivityPending } from "PFApp/activities/helpers";
import { MatchesTimeout } from "PFApp/activities/show/activity_page/parts/tabs/matches/parts/matches_timeout";
import { useActivityMatches } from "PFApp/activities/show/hooks/use_activity_matches";
import { useActivityTemplate } from "PFApp/activities/show/hooks/use_activity_template";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useMatchesStatusText } from "PFApp/activities/show/hooks/use_matches_status_text";
import BrainLoading from "PFComponents/brain_loading/brain_loading";

import { MatchesEmpty } from "./matches_empty";
import css from "./matches_empty_state.module.scss";

const MatchesEmptyStateContent = () => {
  const activity = useCurrentActivity();
  const { matchesFetchState, matchesMeta } = useActivityMatches();

  const template = useActivityTemplate();
  const matchingStateText = useMatchesStatusText(matchesMeta?.status);

  if (matchesMeta?.status !== "ready") {
    return <BrainLoading text={matchingStateText} />;
  }

  if (matchesFetchState === "timeout") {
    return <MatchesTimeout pending={isActivityPending(activity)} template={template!} />;
  }

  return <MatchesEmpty activity={activity} matchesMeta={matchesMeta} />;
};

export const MatchesEmptyState = () => (
  <div className={css.matchesInfo}>
    <MatchesEmptyStateContent />
  </div>
);
